import './personblock.less'

import {Background, m, Picture, View} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {ImageType, WysiwygType} from 'types'
import {style} from 'util/style'
import {Theme} from 'views/theme'
import {Block} from './blocks'
import {ImageBlock, ImageBlockType} from './imageblock'
import {TextBlock} from './textblock'

export type PersonBlockType = {
	image: ImageType
	text: WysiwygType
	minheight: string
	minwidth: string
}

const styles = style('personblock', ['image', 'text'])

export const PersonBlock: FunctionComponent<PersonBlockType> = ({
	image,
	text,
	minheight,
	minwidth
}) => {
	// image cannot be bigger then 600px
	if (Number(minwidth) > 600) minwidth = '600'
	return (
		<Block class={styles} style={{}}>
			<Background
				class={styles.image.toString()}
				style={{
					minWidth: minwidth && minwidth + 'px',
					minHeight: minheight && minheight + 'px'
				}}
				img={image}
			/>
			<div class={styles.text}>
				<Theme.Wysiwyg class={styles.mod('personblock')}>{text}</Theme.Wysiwyg>
			</div>
		</Block>
	)
}
